module.exports = __webpack_public_path__ + "img/network.d2ea25f4.png";